import * as Yup from 'yup'


export const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email('Wrong email format.')
      .min(3, 'Minimum 3 symbols.')
      .max(50, 'Maximum 50 symbols.')
      .required('Email is required.'),
  })